import "./SearchTag.scss";

interface ITagProps {
  title: string;
  onClick: (value: string) => void;
}

export const SearchTag = ({ title, onClick }: ITagProps) => {
  const handleClick = () => {
    onClick(title);
  };

  return (
    <li className="Tag" onClick={handleClick}>
      <button aria-label={`${title} tag`}>{title}</button>
    </li>
  );
};
